import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Defines the default token refresh buffer duration.
 */
export var TokenRefreshBufferMs = 2 * 60 * 1000; // 2 Minutes

/**
 * Provides an {@link AccessTokenCache} implementation which clears
 * the cached {@link AccessToken}'s after the expiresOnTimestamp has
 * passed.
 *
 * @deprecated No longer used in the bearer authorization policy.
 */

export var ExpiringAccessTokenCache = /*#__PURE__*/function () {
  /**
   * Constructs an instance of {@link ExpiringAccessTokenCache} with
   * an optional expiration buffer time.
   */
  function ExpiringAccessTokenCache() {
    var tokenRefreshBufferMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TokenRefreshBufferMs;

    _classCallCheck(this, ExpiringAccessTokenCache);

    this.cachedToken = undefined;
    this.tokenRefreshBufferMs = tokenRefreshBufferMs;
  }
  /**
   * Saves an access token into the internal in-memory cache.
   * @param accessToken - Access token or undefined to clear the cache.
   */


  _createClass(ExpiringAccessTokenCache, [{
    key: "setCachedToken",
    value: function setCachedToken(accessToken) {
      this.cachedToken = accessToken;
    }
    /**
     * Returns the cached access token, or `undefined` if one is not cached or the cached one is expiring soon.
     */

  }, {
    key: "getCachedToken",
    value: function getCachedToken() {
      if (this.cachedToken && Date.now() + this.tokenRefreshBufferMs >= this.cachedToken.expiresOnTimestamp) {
        this.cachedToken = undefined;
      }

      return this.cachedToken;
    }
  }]);

  return ExpiringAccessTokenCache;
}();